import React from "react";
import { WeekViewCalendarView } from "./view";
import { styles } from "./styles";

export class WeekViewCalendar extends React.Component {
  render() {
    return <WeekViewCalendarView {...this.props} styles={styles} />;
  }
}
